import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { FuseConfigService } from '../../../core/services/config.service'
import { fuseAnimations } from '../../../core/animations'
import { FuseTranslationLoaderService } from '../../../core/services/translation-loader.service'
import { dutchLock } from './i18n/nl'
import { UserModel } from '../../models/user.model'
import { AuthService } from '../../../auth.service'
import { TokenModel } from '../models/token.model'
import { ActivatedRoute, Router } from '@angular/router'
import { Observable } from 'rxjs/Observable'
import { HttpErrorResponse } from '@angular/common/http'

@Component({
  selector: 'app-lock',
  templateUrl: './lock.component.html',
  styleUrls: ['./lock.component.scss'],
  animations: fuseAnimations,
})
export class LockComponent implements OnInit {
  lockForm: FormGroup
  lockFormErrors: any
  user: UserModel
  returnUrl: string
  isLoading = false
  visibleMessage: string

  constructor(
    private route: ActivatedRoute,
    private fuseConfig: FuseConfigService,
    private formBuilder: FormBuilder,
    private translator: FuseTranslationLoaderService,
    private authService: AuthService,
    private router: Router,
  ) {
    this.translator.loadTranslations(dutchLock)
    this.fuseConfig.setSettings({
      layout: {
        navigation: 'none',
        toolbar: 'none',
        footer: 'none',
      },
    })

    this.lockFormErrors = {
      username: {},
    }
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('profile'))

    this.lockForm = this.formBuilder.group({
      username: [
        {
          value: this.user.email,
          disabled: true,
        },
        Validators.required,
      ],
    })

    this.lockForm.valueChanges.subscribe(() => {
      this.onLockFormValuesChanged()
    })

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/administrations'
  }

  onLockFormValuesChanged() {
    for (const field in this.lockFormErrors) {
      if (!this.lockFormErrors.hasOwnProperty(field)) {
        continue
      }

      // Clear previous errors
      this.lockFormErrors[field] = {}

      // Get the control
      const control = this.lockForm.get(field)

      if (control && control.dirty && !control.valid) {
        this.lockFormErrors[field] = control.errors
      }
    }
  }

  // onLogin() {
  //   this.authService.getMagicToken(this.lockForm.get('username').value)
  //     .subscribe(
  //       (data) => {
  //         const token = new TokenModel(data);
  //         localStorage.setItem('token', JSON.stringify(token));
  //         this.router.navigate([this.returnUrl]);
  //
  //       },
  //       (error) => {
  //         this.lockFormErrors.login.failed = true;
  //       });
  // }

  getMagicLink(): void {
    this.isLoading = true
    this.visibleMessage = 'LOGIN.SENDING_MAGIC_LINK'
    this.authService
      .getMagicToken(this.lockForm.get('email').value)
      .map((res: {}) => {
        this.isLoading = false
        this.visibleMessage = 'LOGIN.SENT_MAGIC_LINK'
        return Observable.of(res)
      })
      .catch((err: HttpErrorResponse) => {
        this.lockFormErrors.login.failed = true
        this.visibleMessage = 'LOGIN.MAGIC_LINK_FAILURE'
        return Observable.throw(err)
      })
      .subscribe()
  }
}



// WEBPACK FOOTER //
// ./src/app/main/authentication/lock/lock.component.ts